import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [ "retailers", "groups" ];

  connect() {
    // As the Group dropdown isn't always rendered, check its there before using it's value
    if (this.hasGroupsTarget) {
      this.updateRetailerList(this.groupsTarget.value);
    }
  }

  change(ev) {
    const target = ev.currentTarget;
    const selectedGroupId = target.value;
    this.updateRetailerList(selectedGroupId);
  }

  updateRetailerList(id) {
    const retailerOptions = this.retailersTarget.querySelectorAll('option');

    retailerOptions.forEach((option) => {
      if (option.getAttribute('data-group') === id) {
        option.classList.remove('d-none');
      } else {
        option.classList.add('d-none');
      }
    });

    // Preselect the retailers dropdown with the first option of the filtered list(if there are any!)
    const selectedRetailerOptions = this.retailersTarget.querySelectorAll(`[data-group="${id}"]`);

    this.retailersTarget.value = selectedRetailerOptions.length > 0 ? selectedRetailerOptions[0].value : "";
  }
}
